import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Contact from '../components/sections/Contact';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <Header />
      <main>
        <section className="relative bg-slate-900 py-24 md:py-32">
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-800" />
          <div className="container mx-auto px-4 relative z-10 pt-16">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">聯絡我們</h1>
            <p className="text-slate-300 text-lg max-w-2xl">欲了解更多詳情，請與金晉物業代理的專業團隊聯繫。</p>
          </div>
        </section>
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
